import {
  Login,
  Leftmenu,
  Topbar,
  Home,
  Homemain,
  Homevfpmenu,
  Homemessage,
  Homememo,
  Homecontact,
  Warehousesupplier,
  Crmmain,
  Crmvfpmenu,
  Crmchance,
  Crm,
  Crmchancestat,
  Crmhope,
  Crmhopecolleague,
  Crmhopeshare,
  Crmhopestat,
  Client,
  Clientmain,
  Clientvfpmenu,
  Clientsign,
  Clientsigncolleague,
  Clientsignstat,
  Clientsignshare,
  Clientcontract,
  Visit,
  Visitmain,
  Visitstat,
  Visitunit,
  Visitrecord,
  Visitvfpmenu,
  Recruitmentvfpmenu,
  Recruitment,
  Recruitmentinterview,
  Recruitmenteesume,
  Recruitmentmain,
  Usermain,
  Uservfpmenu,
  Userlogs,
  Setting,
  Settingrole,
  Settingaccount,
  Settingvfpmenu,
  Settinglogs,
  Settingclient,
  Settingcrm,
  Settingrecruitment,
  Settingvisit,
  Settinglink,
  Homeaffiche,
  Crmrecycle,
  Crmblacklist,
  Crmfilter,
  Crmlecture,
  Warehouse,
  Warehousemain,
  Warehousevfpmenu,
  Warehousedict,
  Warehousegoods,
  Warehousebill,
  Warehouserepertory,
  Warehouseselllog,
  Warehousegoodslog,
  Warehouseaccountslog,
  Dealermain,
  Dealervfpmenu,
  Dealer,
  Dealeruser,
  Dealerimpower,
  Dealerdiscount,
  Dealerprice,
  Dealerorder,
  Dealersend,
  Dealeraccount,
  Dealerinvoice,
  Statistics,
  Statisticsmain,
  Statisticsvfpmenu,
  Statisticsdealer,
  Settingfiles,
  Settingtimedtask,
  Dealerarticle,
  Marktinggroup,
  Warehouseclearaccount,
  Statisticsdefault,
  Warehousesearchcode,
  Statisticsbuyerstats,
  Settingheadimgs,
  Mallmain,
  Mallvfpmenu,
  MalMarktingdiscounts,
  Mallnav,
  User,
  Mallad,
  Mallsend,
  Mallorder,
  Malluser,
  Mallaccount,
  Mallinvoice,
  Mallarticle,
  Warehousepinpai,
  Marktingpresented,
  Statisticsmall,
  Settingstatic,
  Statisticsbuyerstatshome,
  Statisticsselltongji,
  Statisticssellmingxi,
  Statisticsselldaifa,
  Statisticssellzhangqi,
  Statisticsinvoicedaishen,
  Statisticsinvoicemingxi,
  Statisticsinvoicedaohang,
  Statisticsinvoicemingxisell,
  Marktingmain,
  Marktingvfpmenu,
  Markting,
  Marktingemail,
  Homesynchronousxchange,
  Marktingwebemail,
  Marktingcombination,
  Marktingarticle,
  Marktingcode,
  Marktingcashback, Mallcatalog,
} from './imports';

export const routes = [
  // 首页大厅
  {
    path: '/home',
    children: [
      // 资产仓库
      {
        path: '/home',
        name: 'home',
        components: {
          default: Homemain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 导航信息
          navArr: [{ title: '首页', path: '/home' }, { title: '工作台', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/message',
        name: 'homemessage',
        components: {
          default: Homemessage,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 导航信息
          navArr: [{ title: '首页', path: '/home' }, { title: '我的消息', path: '' }],
        },
      },
      {
        path: '/home/synchronousxchange',
        name: 'homesynchronousxchange',
        components: {
          default: Homesynchronousxchange,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          // 导航信息
          navArr: [{ title: '首页', path: '/home' }, { title: 'XChange同步', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/affiche',
        name: 'homeaffiche',
        components: {
          default: Homeaffiche,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '公示公告', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/memo',
        name: 'homememo',
        components: {
          default: Homememo,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '备忘录', path: '' }],
        },
      },
      // 资产仓库
      {
        path: '/home/contact',
        name: 'homecontact',
        components: {
          default: Homecontact,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Homevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '首页', path: '/home' }, { title: '通讯录', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Home,
  },
  // // 机会
  // {
  //   path: '/crm',
  //   children: [
  //     // 工作台
  //     {
  //       path: '/crm',
  //       name: 'crm',
  //       components: {
  //         default: Crmmain,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         // 权限标点
  //         rbacNode: 'crm',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '工作台', path: '' }],
  //       },
  //     },
  //     // 公海机会
  //     {
  //       path: '/crm/chance',
  //       name: 'crmchance',
  //       components: {
  //         default: Crmchance,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/chance',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '公海机会', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/crm/chancestat',
  //       name: 'crmchancestat',
  //       components: {
  //         default: Crmchancestat,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/chancestat',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '机会统计', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/crm/hope',
  //       name: 'crmhope',
  //       components: {
  //         default: Crmhope,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/hope',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //
  //     // 机会统计
  //     {
  //       path: '/crm/recycle',
  //       name: 'crmrecycle',
  //       components: {
  //         default: Crmrecycle,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/recycle',
  //         navArr: [{ title: '回收站', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //
  //     // 机会统计
  //     {
  //       path: '/crm/blacklist',
  //       name: 'crmblacklist',
  //       components: {
  //         default: Crmblacklist,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/blacklist',
  //         navArr: [{ title: '黑名单', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/crm/filter',
  //       name: 'crmfilter',
  //       components: {
  //         default: Crmfilter,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/filter',
  //         navArr: [{ title: '全局检索', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //
  //     // 机会统计
  //     {
  //       path: '/crm/hopecolleague',
  //       name: 'crmhopecolleague',
  //       components: {
  //         default: Crmhopecolleague,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/hopecolleague',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '我的同事', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/crm/hopeshare',
  //       name: 'crmhopeshare',
  //       components: {
  //         default: Crmhopeshare,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/hopeshare',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '共享到的', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/crm/hopestat',
  //       name: 'crmhopestat',
  //       components: {
  //         default: Crmhopestat,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'crm/hopestat',
  //         navArr: [{ title: '机会', path: '/crm' }, { title: '数据统计', path: '' }],
  //       },
  //     },
  //     {
  //       path: '/crm/setting',
  //       name: 'settingcrm',
  //       components: {
  //         default: Settingcrm,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Crmvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'setting/crm',
  //         navArr: [{ title: '系统', path: '/setting' }, { title: '机会模块', path: '' }],
  //       },
  //     },
  //   ],
  //   meta: {
  //     // 需要登录控制
  //     NProgress: false,
  //     // 需要登录控制
  //     requireAuth: true,
  //   },
  //   component: Crm,
  // },
  // // 机会
  // {
  //   path: '/client',
  //   children: [
  //     // 工作台
  //     {
  //       path: '/client',
  //       name: 'client',
  //       components: {
  //         default: Clientmain,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '工作台', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/client/sign',
  //       name: 'clientsign',
  //       components: {
  //         default: Clientsign,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/sign',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '我负责的', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/client/signcolleague',
  //       name: 'clientsigncolleague',
  //       components: {
  //         default: Clientsigncolleague,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/signcolleague',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '我的同事', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/client/signshare',
  //       name: 'clientsignshare',
  //       components: {
  //         default: Clientsignshare,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/signshare',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '共享到的', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/client/signstat',
  //       name: 'clientsignstat',
  //       components: {
  //         default: Clientsignstat,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/signstat',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '数据统计', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/client/contract',
  //       name: 'clientcontract',
  //       components: {
  //         default: Clientcontract,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/contract',
  //         navArr: [{ title: '客户', path: '/client' }, { title: '合同文件', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/client/recycle',
  //       name: 'clientrecycle',
  //       components: {
  //         default: Crmrecycle,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/recycle',
  //         navArr: [{ title: '回收站', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //
  //     // 机会统计
  //     {
  //       path: '/client/blacklist',
  //       name: 'clientblacklist',
  //       components: {
  //         default: Crmblacklist,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/blacklist',
  //         navArr: [{ title: '黑名单', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //     // 机会统计
  //     {
  //       path: '/client/filter',
  //       name: 'clientfilter',
  //       components: {
  //         default: Crmfilter,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Clientvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'client/filter',
  //         navArr: [{ title: '全局检索', path: '/crm' }, { title: '我的意向', path: '' }],
  //       },
  //     },
  //   ],
  //   meta: {
  //     // 需要登录控制
  //     NProgress: false,
  //     // 需要登录控制
  //     requireAuth: true,
  //   },
  //   component: Client,
  // },
  // // 签到
  // {
  //   path: '/visit',
  //   children: [
  //     // 工作台
  //     {
  //       path: '/visit',
  //       name: 'visit',
  //       components: {
  //         default: Visitmain,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Visitvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'visit',
  //         navArr: [{ title: '签到', path: '/visit' }, { title: '工作台', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/visit/record',
  //       name: 'visitrecord',
  //       components: {
  //         default: Visitrecord,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Visitvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'visit/record',
  //         navArr: [{ title: '签到', path: '/visit' }, { title: '签到记录', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/visit/unit',
  //       name: 'visitunit',
  //       components: {
  //         default: Visitunit,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Visitvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'visit/unit',
  //         navArr: [{ title: '签到', path: '/visit' }, { title: '事件管理', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/visit/stat',
  //       name: 'visitstat',
  //       components: {
  //         default: Visitstat,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Visitvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'visit/stat',
  //         navArr: [{ title: '签到', path: '/visit' }, { title: '数据统计', path: '' }],
  //       },
  //     },
  //   ],
  //   meta: {
  //     // 需要登录控制
  //     NProgress: false,
  //     // 需要登录控制
  //     requireAuth: true,
  //   },
  //   component: Visit,
  // },
  // // 招聘
  // {
  //   path: '/recruitment',
  //   children: [
  //     // 工作台
  //     {
  //       path: '/recruitment',
  //       name: 'recruitment',
  //       components: {
  //         default: Recruitmentmain,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Recruitmentvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'recruitment',
  //         navArr: [{ title: '招聘', path: '/recruitment' }, { title: '工作台', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/recruitment/resume',
  //       name: 'recruitmentresume',
  //       components: {
  //         default: Recruitmenteesume,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Recruitmentvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'recruitment/resume',
  //         navArr: [{ title: '招聘', path: '/recruitment' }, { title: '人才库', path: '' }],
  //       },
  //     },
  //     // 工作台
  //     {
  //       path: '/recruitment/interview',
  //       name: 'recruitmentinterview',
  //       components: {
  //         default: Recruitmentinterview,
  //         'ui-leftmenu': Leftmenu,
  //         'ui-vfpmenu': Recruitmentvfpmenu,
  //         'ui-topbar': Topbar,
  //       },
  //       meta: {
  //         // 需要登录控制
  //         NProgress: true,
  //         // 需要登录控制
  //         requireAuth: true,
  //         rbacNode: 'recruitment/interview',
  //         navArr: [{ title: '招聘', path: '/recruitment' }, { title: '面试安排', path: '' }],
  //       },
  //     },
  //   ],
  //   meta: {
  //     // 需要登录控制
  //     NProgress: false,
  //     // 需要登录控制
  //     requireAuth: true,
  //   },
  //   component: Recruitment,
  // },
  // 我的
  {
    path: '/user',
    children: [
      // 工作台
      {
        path: '/user',
        name: 'user',
        components: {
          default: Usermain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Uservfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          navArr: [{ title: '我的', path: '/user' }, { title: '我的信息', path: '' }],
        },
      },
      // 工作台
      {
        path: '/user/logs',
        name: 'userlogs',
        components: {
          default: Userlogs,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Uservfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'user/logs',
          navArr: [{ title: '我的', path: '/user' }, { title: '登陆日志', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: User,
  },
  // 设置
  {
    path: '/setting',
    children: [
      // 工作台
      {
        path: '/setting',
        name: 'setting',
        components: {
          default: Settinglogs,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/logs',
          navArr: [{ title: '系统', path: '/setting' }, { title: '登录日志', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/dict',
        name: 'settingdict',
        components: {
          default: Warehousedict,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/dict',
          navArr: [{ title: '系统', path: '/setting' }, { title: '仓库字典', path: '' }],
        },
      },

      {
        path: '/setting/static',
        name: 'settingstatic',
        components: {
          default: Settingstatic,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/static',
          navArr: [{ title: '系统', path: '/setting' }, { title: 'SEO优化', path: '' }],
        },
      },


      // 工作台
      {
        path: '/setting/files',
        name: 'settingfiles',
        components: {
          default: Settingfiles,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/files',
          navArr: [{ title: '系统', path: '/setting' }, { title: '视频音频', path: '' }],
        },
      },
      {
        path: '/setting/timedtask',
        name: 'Settingtimedtask',
        components: {
          default: Settingtimedtask,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/timedtask',
          navArr: [{ title: '系统', path: '/setting' }, { title: '定时任务', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/account',
        name: 'settinglogs',
        components: {
          default: Settingaccount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/account',
          navArr: [{ title: '系统', path: '/setting' }, { title: '账号统筹', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/link',
        name: 'settinglink',
        components: {
          default: Settinglink,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/link',
          navArr: [{ title: '系统', path: '/setting' }, { title: '客户模块', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/role',
        name: 'settingrole',
        components: {
          default: Settingrole,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/role',
          navArr: [{ title: '系统', path: '/setting' }, { title: '角色管理', path: '' }],
        },
      },
      // 工作台
      {
        path: '/setting/recruitment',
        name: 'settingrecruitment',
        components: {
          default: Settingrecruitment,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/recruitment',
          navArr: [{ title: '系统', path: '/setting' }, { title: '签到模块', path: '' }],
        },
      },
      {
        path: '/setting/headimgs',
        name: 'settingheadimgs',
        components: {
          default: Settingheadimgs,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Settingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'setting/headimgs',
          navArr: [{ title: '系统', path: '/setting' }, { title: '前台广告', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Setting,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
  {
    path: '/lecture',
    name: 'lecture',
    component: Crmlecture,
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
  // 机会
  {
    path: '/warehouse',
    children: [
      // 工作台
      {
        path: '/warehouse',
        name: 'warehouse',
        components: {
          default: Warehousemain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '工作台', path: '' }],
        },
      },
      // 工作台
      {
        path: '/warehouse/pinpai',
        name: 'warehousepinpai',
        components: {
          default: Warehousepinpai,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/pinpai',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '品牌字典', path: '' }],
        },
      },
      {
        path: '/warehouse/goods',
        name: 'warehousegoods',
        components: {
          default: Warehousegoods,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/goods',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '商品字典', path: '' }],
        },
      },
      {
        path: '/warehouse/bill',
        name: 'warehousebill',
        components: {
          default: Warehousebill,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/bill',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '出入库操作', path: '' }],
        },
      },


      // 机会统计
      {
        path: '/warehouse/supplier',
        name: 'warehousesupplier',
        components: {
          default: Warehousesupplier,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/supplier',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '供应商管理', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/warehouse/clearaccount',
        name: 'warehouseclearaccount',
        components: {
          default: Warehouseclearaccount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/clearaccount',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '待收待支处理', path: '' }],
        },
      },
      {
        path: '/warehouse/repertory',
        name: 'warehouserepertory',
        components: {
          default: Warehouserepertory,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/repertory',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '库存管理', path: '' }],
        },
      },
      {
        path: '/warehouse/selllog',
        name: 'warehouseselllog',
        components: {
          default: Warehouseselllog,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/selllog',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '销售日志', path: '' }],
        },
      },
      {
        path: '/warehouse/goodslog',
        name: 'warehousegoodslog',
        components: {
          default: Warehousegoodslog,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/goodslog',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '商品日志', path: '' }],
        },
      },
      {
        path: '/warehouse/accountslog',
        name: 'warehouseaccountslog',
        components: {
          default: Warehouseaccountslog,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/accountslog',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '金额日志', path: '' }],
        },
      },
      {
        path: '/warehouse/searchcode',
        name: 'Warehousesearchcode',
        components: {
          default: Warehousesearchcode,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Warehousevfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'warehouse/searchcode',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '全局检索激活码', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Warehouse,
  },


  // 经销商部分
  {
    path: '/dealer',
    children: [
      // 工作台
      {
        path: '/dealer',
        name: 'dealer',
        components: {
          default: Dealermain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '工作台', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/article',
        name: 'dealerarticle',
        components: {
          default: Dealerarticle,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/article',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '文章资讯', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/user',
        name: 'dealeruser',
        components: {
          default: Dealeruser,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/user',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '经销商管理', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/impower',
        name: 'dealerimpower',
        components: {
          default: Dealerimpower,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/impower',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '授权管理', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/discount',
        name: 'dealerdiscount',
        components: {
          default: Dealerdiscount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/discount',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '品牌折扣', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/price',
        name: 'dealerprice',
        components: {
          default: Dealerprice,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/price',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '专属价格', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/order',
        name: 'dealeorder',
        components: {
          default: Dealerorder,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/order',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '订单日志', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/dealer/send',
        name: 'dealeend',
        components: {
          default: Dealersend,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/send',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '发货处理', path: '' }],
        },
      },
      // 账单管理
      {
        path: '/dealer/account',
        name: 'dealeraccount',
        components: {
          default: Dealeraccount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/account',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '账单管理', path: '' }],
        },
      },
      // 账单管理
      {
        path: '/dealer/invoice',
        name: 'dealerinvoice',
        components: {
          default: Dealerinvoice,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Dealervfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'dealer/invoice',
          navArr: [{ title: '经销商', path: '/dealer' }, { title: '开票管理', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Dealer,
  },


  // 经销商部分
  {
    path: '/mall',
    children: [
      // 工作台
      {
        path: '/mall',
        name: 'mall',
        components: {
          default: Mallmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall',
          navArr: [{ title: '商城', path: '/mall' }, { title: '工作台', path: '' }],
        },
      },
      {
        path: '/mall/nav',
        name: 'Mallnav',
        components: {
          default: Mallnav,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/nav',
          navArr: [{ title: '商城', path: '/mall' }, { title: '商城管理', path: '' }],
        },
      },
      {
        path: '/mall/catalog',
        name: 'Mallcatalog',
        components: {
          default: Mallcatalog,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/nav',
          navArr: [{ title: '商城', path: '/mall' }, { title: '待付订单', path: '' }],
        },
      },
      {
        path: '/mall/ad',
        name: 'Mallad',
        components: {
          default: Mallad,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/ad',
          navArr: [{ title: '商城', path: '/mall' }, { title: '商城广告', path: '' }],
        },
      },
      {
        path: '/mall/send',
        name: 'Mallsend',
        components: {
          default: Mallsend,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/send',
          navArr: [{ title: '商城', path: '/mall' }, { title: '处理发货', path: '' }],
        },
      },
      {
        path: '/mall/order',
        name: 'Mallorder',
        components: {
          default: Mallorder,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/order',
          navArr: [{ title: '商城', path: '/mall' }, { title: '订单日志', path: '' }],
        },
      },
      {
        path: '/mall/user',
        name: 'Malluser',
        components: {
          default: Malluser,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/user',
          navArr: [{ title: '商城', path: '/mall' }, { title: '注册用户', path: '' }],
        },
      },
      {
        path: '/mall/account',
        name: 'Mallaccount',
        components: {
          default: Mallaccount,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/account',
          navArr: [{ title: '商城', path: '/mall' }, { title: '账单日志', path: '' }],
        },
      },
      {
        path: '/mall/invoice',
        name: 'Mallinvoice',
        components: {
          default: Mallinvoice,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/invoice',
          navArr: [{ title: '商城', path: '/mall' }, { title: '开票管理', path: '' }],
        },
      },
      {
        path: '/mall/article',
        name: 'Mallarticle',
        components: {
          default: Mallarticle,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Mallvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 2,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'mall/article',
          navArr: [{ title: '商城', path: '/mall' }, { title: '文章管理', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Dealer,
  },


  // 数据统计部分
  {
    path: '/statistics',
    children: [
      // 工作台
      {
        path: '/statistics',
        name: 'statistics',
        components: {
          default: Statisticsdefault,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics',
          navArr: [{ title: '数据统计', path: '/statistics' }, { title: '统计', path: '' }],
        },
      },
      // 工作台
      {
        path: '/statistics/warehouse',
        name: 'statisticswarehouse',
        components: {
          default: Statisticsmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/warehouse',
          navArr: [{ title: '数据统计', path: '/statistics' }, { title: '仓库', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/dealer',
        name: 'statisticsdealer',
        components: {
          default: Statisticsdealer,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/dealer',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '经销商', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/statistics/mall',
        name: 'statisticsmall',
        components: {
          default: Statisticsmall,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/mall',
          navArr: [{ title: '数据统计', path: '/statistics/mall' }, { title: '经销商', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/buyerstatshome',
        name: 'statisticsbuyerstatshome',
        components: {
          default: Statisticsbuyerstatshome,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/buyerstatshome',
          navArr: [{ title: '数据统计', path: '/statistics' }, { title: '采购统计', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/buyerstats',
        name: 'statisticsbuyerstats',
        components: {
          default: Statisticsbuyerstats,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/buyerstats',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '采购明细', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/selltongji',
        name: 'statisticsselltongji',
        components: {
          default: Statisticsselltongji,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/selltongji',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '销售统计', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/sellmingxi',
        name: 'statisticssellmingxi',
        components: {
          default: Statisticssellmingxi,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/sellmingxi',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '销售明细', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/selldaifa',
        name: 'statisticsselldaifa',
        components: {
          default: Statisticsselldaifa,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/selldaifa',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '销售待发', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/statistics/invoicedaohang',
        children: [
          // 工作台
          {
            path: '/statistics/invoicedaohang',
            name: 'statistics',
            components: {
              default: Statisticsinvoicemingxi,
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true,
              rbacNode: 'statistics',
              navArr: [{ title: '数据统计', path: '/statistics' }, { title: '统计', path: '' }],
            },
          },
          {
            path: '/statistics/invoicedaohang/invoicemingxisell',
            name: 'statistics',
            components: {
              default: Statisticsinvoicemingxisell,
            },
            meta: {
              // 需要登录控制
              NProgress: true,
              // 需要登录控制
              requireAuth: true,
              rbacNode: 'statistics',
              navArr: [{ title: '数据统计', path: '/statistics' }, { title: '统计', path: '' }],
            },
          },
        ],
        meta: {
          // 需要登录控制
          NProgress: false,
          // 需要登录控制
          requireAuth: true,
        },
        components: {
          default: Statisticsinvoicedaohang,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
      },
      // 机会统计
      {
        path: '/statistics/invoicedaishen',
        name: 'statisticsinvoicedaishen',
        components: {
          default: Statisticsinvoicedaishen,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/invoicedaishen',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '开票待审', path: '' }],
        },
      },


      // 机会统计
      {
        path: '/statistics/sellzhangqi',
        name: 'statisticssellzhangqi',
        components: {
          default: Statisticssellzhangqi,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Statisticsvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/sellzhangqi',
          navArr: [{ title: '数据统计', path: '/statistics/dealer' }, { title: '账期管理', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Statistics,
  },

  // 数据统计部分
  {
    path: '/markting',
    children: [
      // 工作台
      {
        path: '/markting',
        name: 'markting',
        components: {
          default: Marktingmain,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics',
          navArr: [{ title: '营销管理', path: '/markting' }, { title: '营销管理', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/markting/email',
        name: 'marktingemail',
        components: {
          default: Marktingemail,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/buyerstats',
          navArr: [{ title: '营销管理', path: '/markting' }, { title: '图片邮件', path: '' }],
        },
      },

      // 机会统计
      {
        path: '/markting/webemail',
        name: 'marktingwebemail',
        components: {
          default: Marktingwebemail,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'statistics/buyerstats',
          navArr: [{ title: '营销管理', path: '/markting' }, { title: '网页邮件', path: '' }],
        },
      },
      // 工作台
      {
        path: '/markting/presented',
        name: 'Marktingpresented',
        components: {
          default: Marktingpresented,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/presented',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '赠品配置', path: '' }],
        },
      },
      {
        path: '/markting/group',
        name: 'Marktinggroup',
        components: {
          default: Marktinggroup,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/group',
          navArr: [{ title: '仓库', path: '/warehouse' }, { title: '组合商品', path: '' }],
        },
      },
      // 机会统计
      {
        path: '/markting/discounts',
        name: 'MalMarktingdiscounts',
        components: {
          default: MalMarktingdiscounts,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/discounts',
          navArr: [{ title: '商城', path: '/mall' }, { title: '营销活动', path: '' }],
        },
      },
      {
        path: '/markting/article',
        name: 'Marktingarticle',
        components: {
          default: Marktingarticle,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/article',
          navArr: [{ title: '商城', path: '/mall' }, { title: '营销活动', path: '' }],
        },
      },
      {
        path: '/markting/cashback',
        name: 'Marktingcashback',
        components: {
          default: Marktingcashback,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/cashback',
          navArr: [{ title: '商城', path: '/mall' }, { title: '营销活动', path: '' }],
        },
      },
      {
        path: '/markting/code',
        name: 'Marktingcode',
        components: {
          default: Marktingcode,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/code',
          navArr: [{ title: '商城', path: '/mall' }, { title: '营销活动', path: '' }],
        },
      },


      // 机会统计
      {
        path: '/markting/combination',
        name: 'Marktingcombination',
        components: {
          default: Marktingcombination,
          'ui-leftmenu': Leftmenu,
          'ui-vfpmenu': Marktingvfpmenu,
          'ui-topbar': Topbar,
        },
        meta: {
          type: 1,
          // 需要登录控制
          NProgress: true,
          // 需要登录控制
          requireAuth: true,
          rbacNode: 'markting/combination',
          navArr: [{ title: '商城', path: '/mall' }, { title: '营销活动', path: '' }],
        },
      },
    ],
    meta: {
      // 需要登录控制
      NProgress: false,
      // 需要登录控制
      requireAuth: true,
    },
    component: Markting,
  },
  {
    path: '*',
    redirect: '/login',
    meta: {
      // 需要登录控制
      NProgress: true,
      // 需要登录控制
      requireAuth: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js